<template>
	<div class="s-p-4">
		<CFilesExplorer />
	</div>
</template>

<script>
export default {}
</script>
